/** How the gaps screens name a day in a heading or a subtitle — "Thu 1 Oct" — so every sheet and list names it alike. */
export const GAPS_DAY_LABEL_FORMAT = "ccc d LLL";

/** The separator between the facts on one line of context. */
const LABEL_PART_SEPARATOR = " · ";

/**
 * One line of context from its facts — "Nurse 7a-7p · 2A · Thu 1 Oct" — the parts that say something, joined by
 * middots. A part a line does not have (no unit, hours that match the window) is left out rather than leaving a
 * doubled separator behind.
 */
export const joinLabelParts = (parts: readonly (string | null | undefined)[]): string =>
	parts.filter((part): part is string => typeof part === "string" && part !== "").join(LABEL_PART_SEPARATOR);
